export default __webpack_public_path__ + "static/discord-962d1673f3514814406996a6a4af6466.png";